// 开始和结果页面高度
export const START_AND_RESULT_HEIGHT = 452;

// header高度
export const PANEL_HEADER_HEIGHT = 56;

// 标题对齐的tab高度
export const TAB_HEIGHT = 36;

// 内容上下边距
export const CONTENT_MARGIN_TOP = 16;
export const CONTENT_MARGIN_BOTTOM = 13;

// 标题对齐的内容以下的高度
export const PAGE_NUM_AND_BUTTON = 44 + 12 + 8 + 20 + 32;

// iOS底部安全区域
export const SAFE_AREA_BOTTOM = 42;
